import { render, staticRenderFns } from "./role_tree_table.vue?vue&type=template&id=1809d086&scoped=true"
import script from "./role_tree_table.vue?vue&type=script&lang=js"
export * from "./role_tree_table.vue?vue&type=script&lang=js"
import style0 from "./role_tree_table.vue?vue&type=style&index=0&id=1809d086&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1809d086",
  null
  
)

export default component.exports